var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-editor" },
    [
      _vm.loading
        ? _c("ui-loader", {
            staticClass: "product-editor-loader",
            attrs: { size: "64" }
          })
        : _vm._e(),
      !_vm.contentIsEmpty
        ? [
            _c("product-markers", {
              staticClass: "markers",
              attrs: {
                markers: _vm.product.markers,
                plates: _vm.product.plates
              }
            }),
            _c(
              "h1",
              { staticClass: "title" },
              [
                _vm._v("\n      " + _vm._s(_vm.name) + "\n      "),
                _c("vue-client-only", [
                  _vm.code && !_vm.adaptive.isMobile
                    ? _c("span", [
                        _vm._v("\n          " + _vm._s(_vm.code) + "\n        ")
                      ])
                    : _vm._e()
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "gallery" },
              [
                _c("swiper", {
                  attrs: {
                    items: _vm.images,
                    "slides-to-show": 1,
                    dots: "",
                    arrows: ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("media", {
                              attrs: {
                                media: item,
                                width: "400",
                                alt: _vm.name
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    689284617
                  )
                }),
                _c(
                  "vue-client-only",
                  [
                    _vm.product.id && !_vm.adaptive.isMobile
                      ? _c("favorite-button", {
                          attrs: {
                            "product-id": _vm.product.id,
                            "product-price": _vm.currentPrice,
                            "product-code": _vm.product.code,
                            quantity: _vm.computedQty,
                            "sku-id": _vm.activeSku.id
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "prices" }, [
              _c(
                "div",
                { class: ["price price-rub", { discount: _vm.isDiscount }] },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("price")(_vm.currentPrice)) +
                      "\n      "
                  )
                ]
              ),
              _vm.isDiscount
                ? _c("div", { staticClass: "old-price" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("price")(_vm.product.price.basePrice)) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ]),
            _c(
              "vue-client-only",
              [
                _vm.product.id && _vm.adaptive.isMobile
                  ? _c("favorite-button", {
                      staticClass: "favourite",
                      attrs: {
                        "product-id": _vm.product.id,
                        "product-code": _vm.product.code,
                        "sku-id": _vm.activeSku.id
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("select-color", {
              staticClass: "colors",
              attrs: {
                label: "Цвета",
                colors: _vm.colors,
                "active-color": _vm.product.id
              },
              on: { change: _vm.loadProduct }
            }),
            _c(
              "select-size",
              {
                staticClass: "sizes",
                attrs: {
                  "visible-hint": "",
                  label: "Размеры",
                  sizes: _vm.sizes,
                  "active-sku": _vm.activeSku
                },
                on: { change: _vm.changeSize }
              },
              [
                _vm.product.sizeTable
                  ? _c("sizes-table", {
                      staticClass: "tables",
                      attrs: { "product-id": _vm.product.id }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("product-bonus", { attrs: { bonus: _vm.product.bonus } }),
            _c(
              "div",
              { staticClass: "buttons" },
              [
                _c("ui-button", {
                  attrs: {
                    wide: "",
                    disabled: _vm.isSubmitDisabled,
                    text: "Сохранить изменения"
                  },
                  on: { click: _vm.submit }
                }),
                _c("ui-select", {
                  attrs: {
                    value: _vm.computedQty,
                    placeholder: "Выберите количество",
                    options: _vm.qtyOptions
                  },
                  on: { change: _vm.changeQty }
                })
              ],
              1
            ),
            !_vm.product.available
              ? _c("ui-notification", {
                  staticClass: "sold-out",
                  attrs: { title: "Товар распродан" }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }